import React from "react";
import CruiseWizardPage from "@/pages/Cruise/CruiseWizardPage";
import {Icon} from "@reapptor-apps/reapptor-react-components";
import {CruiseGroupSize} from "@/models/Enums";
import Localizer from "@/localization/Localizer";

import styles from "./Group.module.scss";

import groupSizeStandard from "./groups/standard.png";
import groupSizeBig from "./groups/big.png";
import groupSizeWaterbus from "./groups/waterbus.png";
import groupSizeRib from "./groups/rib.png";
import groupSizeClassic from "./groups/classic.png";
import groupSizeSail from "./groups/sail.png";
import groupSizeFishing from "./groups/fishing.png";
import groupSizeHovercraft from "./groups/hovercraft.png";
import groupSizeElectric from "./groups/electric.png";

export interface IGroupProps {
}

interface IGroupState {
}

const franceCode: string = "fr";

export default class Group extends CruiseWizardPage<IGroupProps, IGroupState> {

    state: IGroupState = {
    };

    public async selectAsync(groupSize: CruiseGroupSize): Promise<void> {
        this.wizard.groupSize = groupSize;
        this.saveContext();
        await super.nextAsync();
    }

    public get canNext(): boolean {
        return (this.wizard.groupSize != null);
    }

    public get groupSize(): CruiseGroupSize | null {
        return this.wizard.groupSize;
    }
    
    public renderItem(groupSize: CruiseGroupSize, image: any, label1: string, label2: string, className?: string): React.ReactNode {
        const selectedStyle: any = (groupSize == this.groupSize) && styles.selected;
        const mobileStyle: any = (this.mobile) && styles.mobile;
        return (
            <div className={this.css(styles.item, mobileStyle, selectedStyle, className)} onClick={() => this.selectAsync(groupSize)}>
                <div className={styles.image}>
                    <img src={image} alt={label1}/>
                </div>
                <div className={styles.label}>
                    <div>
                        <span>{this.toMultiLines(label1)}</span>
                    </div>
                    <div>
                        <Icon name={"fal user"} />
                        <span>{label2}</span>
                    </div>
                </div>
            </div>
        );
    }

    public renderContent(): React.ReactNode {
        const isFrance: boolean = (this.wizard.country?.code == franceCode);
        
        return (
            <div className={styles.group}>

                <div className={this.css(styles.container, this.mobile && styles.mobile)}>
                    
                    <div className={styles.row}>
                        
                        { this.renderItem(CruiseGroupSize.Standard, groupSizeStandard, Localizer.cruiseWizardStandard, "1-12") }

                        { this.renderItem(CruiseGroupSize.Big, groupSizeBig, Localizer.cruiseWizardBig, "13-30") }
                        
                        { this.renderItem(CruiseGroupSize.Waterbus, groupSizeWaterbus, Localizer.cruiseWizardWaterbus, "30+") }

                    </div>
                    
                    <div className={styles.row}>

                        {
                            (!isFrance) && (
                                <React.Fragment>

                                    { this.renderItem(CruiseGroupSize.Rib, groupSizeRib, Localizer.cruiseWizardRib, "1-11") }

                                    { this.renderItem(CruiseGroupSize.Sail, groupSizeSail, Localizer.cruiseWizardSail, "1-x") }
                                    
                                </React.Fragment>
                            )
                        }

                        { this.renderItem(CruiseGroupSize.Classic, groupSizeClassic, Localizer.cruiseWizardClassic, "1-11") }

                    </div>

                    {
                        (!isFrance) &&
                        (
                            <React.Fragment>

                                <div className={styles.row}>

                                    { this.renderItem(CruiseGroupSize.Electric, groupSizeElectric, Localizer.cruiseWizardElectric, "1-11", styles.wide) }

                                    { this.renderItem(CruiseGroupSize.Fishing, groupSizeFishing, Localizer.cruiseWizardFishing, "1-x", styles.wide) }

                                    {
                                        (this.desktop) && (this.hovercraftEnabled) &&
                                        (
                                            this.renderItem(CruiseGroupSize.Hovercraft, groupSizeHovercraft, Localizer.cruiseWizardHovercraft, "1-5", this.css(styles.wide, styles.hovercraft))
                                        )
                                    }

                                </div>

                                {
                                    (this.mobile) && (this.hovercraftEnabled) &&
                                    (
                                        <div className={styles.row}>

                                            { this.renderItem(CruiseGroupSize.Hovercraft, groupSizeHovercraft, Localizer.cruiseWizardHovercraft, "1-5", this.css(styles.wide, styles.hovercraft)) }

                                        </div>
                                    )
                                }
                                
                            </React.Fragment>
                        )
                    }
                    
                </div>

            </div>
        );
    }
}